<div class="profile-view">
  <div class="profile">
    <h3 class="page-title animate-fade-in-up">Your Profile</h3>

    <div class="card-img-section">
      <!-- Form Card - Delay 1 -->
      <div class="details-card animate-fade-in-up delay-1">
        <form class="profile-form" [formGroup]="profileForm" #f="ngForm">

          <mat-form-field class="input-full-width" appearance="outline" floatLabel="always">
            <mat-label>Your Name</mat-label>
            <input matInput formControlName="name" placeholder="Enter your full name" name="Your Name">
          </mat-form-field>

          <mat-form-field class="input-full-width" appearance="outline" floatLabel="always">
            <mat-label>Email Address</mat-label>
            <input type="email" matInput formControlName="email" placeholder="example@email.com" readonly />
          </mat-form-field>

          <div *ngIf="formField.email.errors" class="email-validation">
            <div *ngIf="formField.email.errors.required">Email is required</div>
            <div *ngIf="formField.email.errors.email">Please enter a valid email address</div>
          </div>

          <mat-form-field class="input-full-width" appearance="outline" floatLabel="always">
            <mat-label>Office Address</mat-label>
            <textarea matInput placeholder="City, State, Country" name="address" formControlName="address"
              rows="3"></textarea>
          </mat-form-field>

          <div class="phone-input-wrapper">
            <mat-label
              style="font-size: 13px; font-weight: 500; color: #4a5568; margin-bottom: 8px; display: block;">Contact
              Number</mat-label>
            <ngx-intl-tel-input [cssClass]="'mobile-num'" [preferredCountries]="preferredCountries"
              [enableAutoCountrySelect]="true" [enablePlaceholder]="true" [searchCountryFlag]="true"
              [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]" [selectFirstCountry]="false"
              [selectedCountryISO]="CountryISO.India" [maxLength]="15" [phoneValidation]="true"
              [separateDialCode]="true" [numberFormat]="PhoneNumberFormat.National" name="phone"
              formControlName="phone">
            </ngx-intl-tel-input>
          </div>

          <div class="email-validation"
            *ngIf="profileForm.controls['phone'].invalid && profileForm.controls['phone'].touched">
            <div>Please enter a valid mobile number</div>
          </div>

          <div class="text-center">
            <button mat-flat-button color="primary" [disabled]="!(profileForm.valid && profileForm.dirty)"
              (click)="updateProfile()">Update Profile</button>
          </div>
        </form>
      </div>

      <!-- Illustration Section - Delay 2 -->
      <div class="image-section animate-fade-in-up delay-2">
        <img src="../../../assets/profile.png" alt="Profile Illustration">
      </div>
    </div>
  </div>
</div>